var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _vm._l(_vm.data, function(d, idx) {
          return _c("key-value", {
            key: d.key,
            class: { "pt-2": idx > 0 },
            attrs: { data: d }
          })
        }),
        _vm._v(" "),
        _vm.data
          ? _c("div", { staticClass: "row pt-2" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary w-100",
                    on: { click: _vm.add }
                  },
                  [_vm._v(_vm._s(_vm.$t("add")))]
                )
              ])
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-006f9d78", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-006f9d78","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataList.vue
// module id = 27
// module chunks = 1